import { render, staticRenderFns } from "./specialFeatures.vue?vue&type=template&id=54180892&scoped=true&"
import script from "./specialFeatures.vue?vue&type=script&lang=js&"
export * from "./specialFeatures.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./specialFeatures.vue?vue&type=style&index=0&id=54180892&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "54180892",
  "c2bb66b2"
  
)

export default component.exports